import { CustomLogger } from "../Chat/Connection/Matrix/CustomMatrixLogger";
export const customWebRTCLogger = new CustomLogger("webrtc");
